/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CountryDto,
  Person,
  PersonUpdateDto,
} from '../models/index';
import {
    CountryDtoFromJSON,
    CountryDtoToJSON,
    PersonFromJSON,
    PersonToJSON,
    PersonUpdateDtoFromJSON,
    PersonUpdateDtoToJSON,
} from '../models/index';

export interface ApiPersonIgvKennungPutRequest {
    igvKennung: number;
    personUpdateDto?: PersonUpdateDto;
}

export interface ApiPersonIgvRequestGetRequest {
    igvKennung?: number;
    vorname?: string;
    nachname?: string;
    ort?: string;
    gebDat?: Date;
}

export interface ApiPersonLoginIGVKennungPasswordGetRequest {
    iGVKennung: number;
    password: string;
}

export interface ApiPersonRegisterRegisterIdGetRequest {
    registerId: string;
}

/**
 * 
 */
export class PersonApi extends runtime.BaseAPI {

    /**
     */
    async apiPersonCountriesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CountryDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Person/countries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CountryDtoFromJSON));
    }

    /**
     */
    async apiPersonCountriesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CountryDto>> {
        const response = await this.apiPersonCountriesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPersonIgvKennungPutRaw(requestParameters: ApiPersonIgvKennungPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['igvKennung'] == null) {
            throw new runtime.RequiredError(
                'igvKennung',
                'Required parameter "igvKennung" was null or undefined when calling apiPersonIgvKennungPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Person/{igvKennung}`.replace(`{${"igvKennung"}}`, encodeURIComponent(String(requestParameters['igvKennung']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PersonUpdateDtoToJSON(requestParameters['personUpdateDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiPersonIgvKennungPut(requestParameters: ApiPersonIgvKennungPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPersonIgvKennungPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiPersonIgvRequestGetRaw(requestParameters: ApiPersonIgvRequestGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters['igvKennung'] != null) {
            queryParameters['igvKennung'] = requestParameters['igvKennung'];
        }

        if (requestParameters['vorname'] != null) {
            queryParameters['vorname'] = requestParameters['vorname'];
        }

        if (requestParameters['nachname'] != null) {
            queryParameters['nachname'] = requestParameters['nachname'];
        }

        if (requestParameters['ort'] != null) {
            queryParameters['ort'] = requestParameters['ort'];
        }

        if (requestParameters['gebDat'] != null) {
            queryParameters['gebDat'] = (requestParameters['gebDat'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Person/igv-request`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async apiPersonIgvRequestGet(requestParameters: ApiPersonIgvRequestGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.apiPersonIgvRequestGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPersonLoginIGVKennungPasswordGetRaw(requestParameters: ApiPersonLoginIGVKennungPasswordGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Person>> {
        if (requestParameters['iGVKennung'] == null) {
            throw new runtime.RequiredError(
                'iGVKennung',
                'Required parameter "iGVKennung" was null or undefined when calling apiPersonLoginIGVKennungPasswordGet().'
            );
        }

        if (requestParameters['password'] == null) {
            throw new runtime.RequiredError(
                'password',
                'Required parameter "password" was null or undefined when calling apiPersonLoginIGVKennungPasswordGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Person/login/{IGVKennung},{Password}`.replace(`{${"IGVKennung"}}`, encodeURIComponent(String(requestParameters['iGVKennung']))).replace(`{${"Password"}}`, encodeURIComponent(String(requestParameters['password']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonFromJSON(jsonValue));
    }

    /**
     */
    async apiPersonLoginIGVKennungPasswordGet(requestParameters: ApiPersonLoginIGVKennungPasswordGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Person> {
        const response = await this.apiPersonLoginIGVKennungPasswordGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPersonRegisterRegisterIdGetRaw(requestParameters: ApiPersonRegisterRegisterIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Person>> {
        if (requestParameters['registerId'] == null) {
            throw new runtime.RequiredError(
                'registerId',
                'Required parameter "registerId" was null or undefined when calling apiPersonRegisterRegisterIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Person/register/{RegisterId}`.replace(`{${"RegisterId"}}`, encodeURIComponent(String(requestParameters['registerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonFromJSON(jsonValue));
    }

    /**
     */
    async apiPersonRegisterRegisterIdGet(requestParameters: ApiPersonRegisterRegisterIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Person> {
        const response = await this.apiPersonRegisterRegisterIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
